export const declensionOfNouns = (count: number, forms: string[]): string => {
  if (!forms || !Array.isArray(forms) || forms.length < 3) {
    return `${count}`
  }

  const [nominative, genitiveSingular, genitivePlural] = forms

  if (count % 100 >= 11 && count % 100 <= 19) {
    return `${count} ${genitivePlural}`
  }

  switch (count % 10) {
    case 1:
      return `${count} ${nominative}`
    case 2:
    case 3:
    case 4:
      return `${count} ${genitiveSingular}`
    default:
      return `${count} ${genitivePlural}`
  }
}
